import React from 'react';

export default function BlockContainer({
  title = '',
  description = '',
  align = 'center',
  bgColor = 'var(--stone)',
  textColor = 'var(--text-dark)',
  padding = '80px',
  paddingTop = '',
  paddingBottom = '',
  fullWidth = false,
  children,
  noWhiteSpace = false,
}) {
  const alignClass = `text-${align}`;
  const whiteSpaceClass = noWhiteSpace ? '' : 'whitespace-pre-line';

  return (
    <div
      style={{
        backgroundColor: bgColor,
        paddingTop: paddingTop || padding,
        paddingBottom: paddingBottom || padding,
        color: textColor,
      }}
    >
      <div className={fullWidth ? 'w-full' : 'max-width'}>
        <div className={`mx-auto my-0 ${whiteSpaceClass} ${alignClass}`}>
          {title || description ? (
            <div className="max-w-3xl mx-auto">
              {title && (
                <h2 className="text-[2.25rem] leading-[1.2] !mb-6">{title}</h2>
              )}
              {description && (
                <p className="text-[0.9rem] leading-[1.6] lg:px-10 !mb-12">
                  {description}
                </p>
              )}
            </div>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
}
